import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import Loader from 'components/mediabay-ui/components/Loader';
import Icon from 'components/mediabay-ui/components/Icon';
import trimHtml from '../../../utils/trimHtml';
import bgImage from '../../../assets/content-blur-bg.jpg';
import {
  // Season,
  Container,
  DetailsContainer,
  DetailsPicture,
  DescriptionWrapper,
  DetailsHeading,
  DetailsSubheading,
  DetailsList,
  DetailsDescription,
  DetailsNameTitle,
} from './styles';
import AdFoxBanner from '../../Ads/AdFoxBanner';

class DetailsWrapper extends React.Component {
  static propTypes = {
    currentLanguage: PropTypes.string.isRequired,
    videoDetails: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.object,
    }).isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      isFetching: true,
      videoDetails: this.props.videoDetails,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.videoDetails.status !== null) {
      return {
        isFetching: false,
        videoDetails: nextProps.videoDetails,
      };
    }

    return null;
  }

  render() {
    let content = null;
    const { currentLanguage } = this.props;
    const { isFetching, videoDetails } = this.state;

    if (isFetching) {
      content = <Loader />;
    } else if (videoDetails.status === 404) {
      content = <Redirect to="/404" />;
    } else if (videoDetails.status === 200) {
      content = (
        <DetailsContainer>
          <DetailsPicture
            src={videoDetails.data.picture.replace('.jpg', '.200.jpg')}
            alt={videoDetails.data.title[currentLanguage] || videoDetails.data.title['ru']}
          />
          <DescriptionWrapper>
            <DetailsHeading level={2} itemprop="headline">
              {videoDetails.data.title[currentLanguage] || videoDetails.data.title['ru']}
            </DetailsHeading>

            <DetailsSubheading>
              {videoDetails.data.producer.map(producer => (
                <span key={producer.id} style={{ marginRight: 15 }}>
                  {
                    producer.name[currentLanguage] || producer.name['ru']
                  }
                </span>
              ))}
            </DetailsSubheading>

            <DetailsList>
              <li>
                <span>
                  {new Date(videoDetails.data.dateCreated).getFullYear()}
                </span>
              </li>
              <li>
                <span>
                  {videoDetails.data.yearLimit}
                </span>
              </li>
              {
                !!videoDetails.data.rating.imdb && (
                  <li>
                    <Icon icon="imdb" width={28} height={28} style={{ marginRight: 3 }} />
                    <span>
                      {
                        Number.parseFloat(videoDetails.data.rating.imdb).toFixed(1)
                      }
                    </span>
                  </li>
                )
              }
              {
                !!videoDetails.data.rating.kinopoisk && (
                  <li>
                    <Icon icon="kinopoisk" width={20} height={20} style={{ marginRight: 3 }} />
                    <span>
                      {
                        Number.parseFloat(videoDetails.data.rating.kinopoisk).toFixed(1)
                      }
                    </span>
                  </li>
                )
              }
            </DetailsList>

            <DetailsDescription itemprop="description">
              {
                React.createElement(
                  'p',
                  null,
                  trimHtml(videoDetails.data.description[currentLanguage] || videoDetails.data.description['ru']),
                )
              }

              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                  videoDetails.data.actors.map(actor => (
                    <Link to={`/actor/${actor.id}`} key={actor.id} style={{ width: 70, marginRight: 20 }}>
                      <img
                        src={actor.photo.replace('.jpg', '.70.jpg')}
                        alt={actor.name[currentLanguage] || actor.name['ru']}
                        width={70}
                        height={70}
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                      />

                      <DetailsNameTitle>
                        {actor.name[currentLanguage] || actor.name['ru']}
                      </DetailsNameTitle>
                    </Link>
                  ))
                }
              </div>
            </DetailsDescription>
          </DescriptionWrapper>
        </DetailsContainer>
      );
    }

    return (
      <Container backgroundUrl={bgImage}>
        <div style={{ marginBottom: 30 }}>
          <AdFoxBanner slot={1} />
        </div>
        {content}
      </Container>
    );
  }
}

export default DetailsWrapper;
